import CountryPageRenderer from '../components/CountryPageRenderer';
import southAfricaData from '../data/country-pages/south-africa';

export default function SouthAfricaCountryPage() {
  return <CountryPageRenderer data={southAfricaData} />;
}
